module.exports = __webpack_public_path__ + "img/discharge.3e9e6ce1.svg";